const routes = {
  file: '/users/:userId/files/:fileId',

  albums: '/users/:userId/albums',
  album: '/users/:userId/albums/:albumId',

  timeline: '/users/:userId/timeline',
  timelinePeriod: '/users/:userId/timeline/period/:periodId',
  timelinePeriodFile: '/users/:userId/timeline/period/:periodId/file/:fileId',

  tags: '/users/:userId/tags',
  tag: '/users/:userId/tags/:tagId',

  people: '/users/:userId/people',
  person: '/users/:userId/people/:personId',

  container: '/users/:userId/containers/:containerId',
  projects: '/users/:userId/print-projects',

  userProfile: '/users/:userId',

  digitizationProjects: '/digitization-projects/:boxId',
};

export function useBuildRoute() {
  const buildRoute = ({route, params, query}) => {
    let r = buildRouteParams(route, params);

    if (params.shareToken) {
      r = `${r}/${params.shareToken}`;
    }

    if (query) {
      r = `${r}${buildQueryString(query)}`;
    }

    return r;
  }

  return {
    toFile({file, userId = useSessionStore().currentUser?.slug, shareToken, query = {}}) {
      return buildRoute({
        route: routes.file,
        params: {
          fileId: file.id,
          userId,
          shareToken
        },
        query
      });
    },
    toAlbums() {
      return buildRoute({route: routes.albums, params: {userId: useSessionStore().currentUser.slug}})
    },
    toAlbum({album, userId = useSessionStore().currentUser.slug, shareToken, query = {}}) {
      return buildRoute({
        route: routes.album,
        params: {
          albumId: album.slug,
          userId,
          shareToken
        },
        query
      });
    },

    toTimeline({userId = useSessionStore().currentUser.slug, query = {}} = {}) {
      return buildRoute({
        route: routes.timeline,
        query,
        params: {userId}
      });
    },

    toTimelinePeriod({periodId, userId = useSessionStore().currentUser.slug, query = {}}) {
      return buildRoute({
        route: routes.timelinePeriod,
        params: {userId, periodId},
        query
      });
    },

    toTimelinePeriodFile({fileId, periodId, userId = useSessionStore().currentUser.slug, query = {}}) {
      return buildRoute({
        route: routes.timelinePeriodFile,
        params: {fileId, userId, periodId},
        query
      });
    },

    toTags() {
      return buildRoute({route: routes.tags, params: {userId: useSessionStore().currentUser.slug}})
    },
    toTag({tag, userId = useSessionStore().currentUser.slug, shareToken, query = {}}) {
      return buildRoute({
        route: routes.tag,
        params: {
          tagId: tag.slug,
          userId,
          shareToken
        },
        query
      });
    },


    toPeople({query = {}} = {}) {
      return buildRoute({
        route: routes.people,
        params: {userId: useSessionStore().currentUser.slug},
        query
      })
    },

    toPerson({person, userId = useSessionStore().currentUser.slug, shareToken, query = {}}) {
      return buildRoute({
        route: routes.person,
        params: {
          personId: person.slug ,
          userId,
          shareToken
        },
        query
      });
    },

    toContainer({container, userId = useSessionStore().currentUser.slug, shareToken}) {
      return buildRoute({
        route: routes.container,
        params: {
          containerId: container.id,
          userId,
          shareToken
        }
      });
    },

    toUserProfile({user, query = {}}) {
      return buildRoute({
        route: routes.userProfile,
        params: {
          userId: user.slug || user.id
        },
        query
      });
    },
    toProjects() {
      return buildRoute({route: routes.projects, params: {userId: useSessionStore().currentUser.slug}})
    },

    toDigitizationProject({boxId, shareToken}) {
      //console.log(boxId, shareToken);
      return buildRoute({route: routes.digitizationProjects, params: {boxId, shareToken}});
    }
  }
}
